import * as api from '../api/diamond'
import { PriceSlider } from '../utils/slider-configs'
import hash from 'object-hash'

export const setFilterVal = (key, value) => {
  return {
    type: 'SET_SEARCH_FILTER_VALUE',
    key: key,
    value: value
  }
}

export const setFilterValues = (payload) => {
  return {
    type: 'SET_SEARCH_FILTER_VALUES',
    payload
  }
}

export const setResults = resultsArr => {
  return {
    type: 'SET_SEARCH_RESULTS',
    value: resultsArr
  }
}

export const addHighlightedDiamondRow = (modalRow) => {
  return {
    type: 'ADD_HIGHLIGHTED_DIAMOND_ROW',
    value: hash.sha1({'Name Code': modalRow['Name Code'], 'Stock Number': modalRow['Stock Number']})
  }
}

export const setRow = (modalRow, modalRowIndex) => {
  return {
    type: 'SET_ROW',
    value: { modalRow, modalRowIndex }
  }
}

export const openModal = () => {
  return {
    type: 'OPEN_MODAL',
    value: 'diamondDetails'
  }
}

export const openDetailsModal = (modalRow, modalRowIndex) => {
  return (dispatch, getState) => {
    dispatch(setRow(modalRow, modalRowIndex))
    dispatch(addHighlightedDiamondRow(modalRow))
    dispatch(openModal())
    return Promise.resolve()
  }
}

export const closeModal = () => {
  return {
    type: 'CLOSE_MODAL'
  }
}

export const reset = () => {
  return {
    type: 'RESET_SEARCH'
  }
}

export const toggleAdvanced = val => {
  return {
    type: 'TOGGLE_ADVANCED_PANEL',
    value: !val
  }
}

export const onPagerClicked = val => {
  return {
    type: 'SET_PAGE',
    value: val
  }
}

export const addCompareItem = item => {
  return {
    type: 'ADD_COMPARE_ITEM',
    value: item
  }
}

export const removeCompareItem = id => {
  return {
    type: 'REMOVE_COMPARE_ITEM',
    value: id
  }
}

export const setCompareData = item => {
  return {
    type: 'SET_COMPARE_DATA',
    value: item
  }
}

export const swapCompareData = (pos1, pos2) => {
  return {
    type: 'SWAP_COMPARE_DATA',
    value: { pos1, pos2 }
  }
}

export const removeItem = item => {
  return {
    type: 'REMOVE_ITEM',
    value: item
  }
}

export const clearCompareData = () => {
  return {
    type: 'CLEAR_COMPARE_DATA'
  }
}

export const openCompareModal = () => {
  return {
    type: 'OPEN_MODAL',
    value: 'diamondCompare'
  }
}

export const setPageAndsearch = (selected = 0) => {
  return (dispatch, getState) => {
    dispatch(onPagerClicked(selected))
    dispatch(search())
  }
}

export const setPageSizeAndSearch = (pageSize = 0) => {
  return (dispatch, getState) => {
    dispatch(onPagerClicked(0))
    dispatch(setResultsItemsPerPage(parseInt(pageSize)))
    dispatch(search())
  }
}

export const search = () => {
  return (dispatch, getState) => {
    return api
      .diamondSearch(
        getState().diamondSearch.filters,
        getState().diamondSearch.currentPage,
        getState().settings,
        getState().diamondSearch.pagination.hits_per_page
      )
      .then((res) => dispatch(setResults(res.data)))
      .catch(() => {
        const blankResults = {
          pagination: {
            total_hits: 0,
            current_page: 0,
            hits_per_page: 25
          },
          hits: []
        }
        dispatch(setResults(blankResults))
      })
  }
}

export const getAllSuppliers = () => {
  return (dispatch, getState) => {
    api
      .getAllSuppliers()
      .then(res => dispatch(setSupplierList(res.data)))
      .catch(error => {
        console.error('Failed to fetch supplier list')
        console.log(error)
      })
  }
}

export const setFindADiamondParams = (
  jewelryParams,
  budget = PriceSlider.max
) => {
  let params = {}
  // Set the price range from 0 to the remaning budget and the value for 'priceUnit' to 'each'
  // If the jewelry type is Stud Earring, then the budget should be cut in to half
  // If the jewelry type is Stock Item, the the budget should be 1 / primary_diamond_qty
  const applicableBudget = (jewelryParams, budget) => {
    if (jewelryParams.jewelry_type === 'StudEarring') {
      return parseFloat((budget / 2).toFixed(2))
    } else if (jewelryParams.jewelry_type === 'StockItem') {
      return parseFloat((budget / jewelryParams.primary_diamond_qty).toFixed(2))
    } else {
      return budget
    }
  }
  const shouldFindPair = jewelryParams => {
    if (jewelryParams.jewelry_type === 'StudEarring') {
      return true
    }
    if (
      jewelryParams.jewelry_type === 'StockItem' &&
      parseFloat(jewelryParams.primary_diamond_qty) === 2
    ) {
      return true
    }
    return false
  }
  // Set the shape of the diamond
  params = Object.assign(params, {
    price: [0, applicableBudget(jewelryParams, budget)],
    priceUnit: 'each',
    shapes: jewelryParams.shapes
  })
  // If shape is round then set color range to D-I
  // If shape is round then set clarity range to FL-SI1
  if (jewelryParams.shapes && jewelryParams.shapes[0] === 'round') {
    params = Object.assign(params, {
      colour: [0, 6],
      clarity: [0, 7]
    })
  }
  if (jewelryParams.shapes && jewelryParams.shapes[0] !== 'round') {
    // If any shape other than round and with a centre halo then set colour range to D-H
    // If any shape other than round and with no centre halo then set colour range to D-I
    if (jewelryParams.has_central_halo) {
      params = Object.assign(params, {
        colour: [0, 5]
      })
    } else {
      params = Object.assign(params, {
        colour: [0, 6]
      })
    }
    // If shape is Emerald or Asscher then set clarity range to FL-VS2
    // If shape other than round/emerald/asscher then set clarity range to FL-SI1
    if (
      jewelryParams.shapes[0] === 'emerald' ||
      jewelryParams.shapes[0] === 'asscher'
    ) {
      params = Object.assign(params, {
        clarity: [0, 6]
      })
    } else {
      params = Object.assign(params, {
        clarity: [0, 7]
      })
    }
  }

  // if jewelry type is StudEarring or if jewelry type is StockItem and primary_diamond_qty == 2
  // 1). 'matchedsets' should be set to true
  // 2). 'sortByField' should be set to 'Pair Sort ID Hash'
  params = Object.assign(params, {
    matchedsets: shouldFindPair(jewelryParams),
    sortByField: shouldFindPair(jewelryParams) ? 'Pair Sort ID Hash' : 'Weight',
    orderBy: shouldFindPair(jewelryParams) ? 'asc' : 'desc'
  })

  return {
    type: 'SET_FIND_A_DIAMOND_PARAMS',
    value: params
  }
}

const setSupplierList = suppliers => {
  return {
    type: 'SET_SUPPLIER_LIST',
    value: suppliers
  }
}

export const setResultsItemsPerPage = (data) => {
  return {
    type: 'SET_HITS_PER_PAGE',
    value: data
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js